import React from 'react'
import PropTypes from 'prop-types'
import { MetaTags } from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import StockOutForm from "../../containers/stock-out/StockOutForm"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { addNewStockOut } from "../../store/stock-out/actions"

//StockOut
const AddNewStockOut = props => {
  const { addNewStockOut, history } = props

  const handleOnSubmit = (data) => {
    addNewStockOut(data)
    history.push(`/stock-out`)
  }

  const handleOnCancel = () => {
    history.push(`/stock-out`);
  }

  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Stock Out | CR TechSoft</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
                title="Home"
                backLink={ `/stock-out` }
                breadcrumbItem={ `Add New Stock-out` }
            />
            <Row>
              <Col md={ 12 }>
                <StockOutForm onSubmit={ handleOnSubmit } onCancel={ handleOnCancel }/>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  )
}

AddNewStockOut.propTypes = {
  addNewStockOut: PropTypes.func,
  match: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = ({ stockIn }) => {
  return stockIn
}

export default withRouter(
    connect(mapStateToProps, {
      addNewStockOut,
    })(AddNewStockOut)
)
